import { Document, Account, User } from '@tenderd/schema';
import React, { useEffect, useState } from 'react';
import './ZohoBugModal.css';
import { Spin } from 'antd';

const formId = 'zf_div_eBcb_v-KRogKhpLvBBERwYcSLUjeaynMi5SAZMvynfw';
function loadForm() {
    try {
        var f = document.createElement('iframe');
        f.style.border = 'none';
        f.style.transition = 'all 0.5s ease';
        f.style.width = '600px';
        f.style.overflowY = 'auto';
        var d = document.getElementById(
            formId
        );

        d.appendChild(f);
        window.addEventListener(
            'message',
            function () {
                var evntData = (event as any).data;
                if (evntData && evntData.constructor == String) {
                    var zf_ifrm_data = evntData.split('|');
                    if (zf_ifrm_data.length == 2) {
                        var zf_perma = zf_ifrm_data[0];
                        var zf_ifrm_ht_nw =
                            parseInt(zf_ifrm_data[1], 10) + 15 + 'px';
                        var iframe = document
                            .getElementById(
                                formId
                            )
                            .getElementsByTagName('iframe')[0];
                        if (
                            iframe.src.indexOf('formperma') > 0 &&
                            iframe.src.indexOf(zf_perma) > 0
                        ) {
                            var prevIframeHeight = iframe.style.height;
                            if (prevIframeHeight != zf_ifrm_ht_nw) {
                                iframe.style.height = zf_ifrm_ht_nw;
                            }
                        }
                    }
                }
            },
            false
        );
    } catch (e) { }
}

const ZohoBugModal: React.FC<{ open: number, user: Document<User> }> = ({
    open,
    user
}) => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        loadForm();
        const iframe = document
            .getElementById(
                formId
            )
            .getElementsByTagName('iframe')[0];
        iframe.setAttribute(
            'src',
            `https://forms.zohopublic.com/tenderd/form/BugTracker/formperma/eBcb_v-KRogKhpLvBBERwYcSLUjeaynMi5SAZMvynfw?zf_rszfm=1&name=${user?.doc?.name}&email=${user?.doc?.email}`
        );
        iframe.onload = () => {
            setLoading(false);
        };
    }, [open]);

    return (
        <Spin spinning={loading}>
            <div
                key={open}
                className="zoho-form-modal"
                id={formId}
            />
        </Spin>
    );
};

export default ZohoBugModal;
